import { ButtonV2, Dialog } from '@cimplico/components';
import { useState } from 'react';
import { toastNotification } from '../../../../../components/toast/Toast';
import { useUnlinkAtosaTaxpayer } from '../../../../../queries/use-unlink-atosa-taxpayer';
import { Entity } from '../../../../../types/entity';

type LinkedTaxpayerProps = {
    entity: Entity;
};
function LinkedTaxpayer({ entity }: LinkedTaxpayerProps): JSX.Element {
    const atosa = entity.integrations.atosa;
    const unlinkTaxpayer = useUnlinkAtosaTaxpayer();
    const [confirm, setConfirm] = useState(false);

    function unlink(): void {
        if (!atosa) {
            return;
        }
        unlinkTaxpayer.mutate(
            { entityId: entity.id, mappingId: atosa.id },
            {
                onSuccess: () => {
                    toastNotification('success', 'Successfully unlinked taxpayer!');
                },
                onError: (res) => {
                    toastNotification('error', 'Unable to unlink taxpayer.', res.response?.data?.message);
                },
            }
        );
    }

    return (
        <div>
            <Dialog
                type="error"
                title={`Unlink ${atosa.name}`}
                description="Are you sure you want to unlink this taxpayer from this entity? Calculations using it's data may be affected."
                primaryAction="Confirm"
                secondaryAction="Cancel"
                onPrimaryActionClick={unlink}
                isLoading={unlinkTaxpayer.isLoading}
                isOpen={confirm}
                onClose={(): void => setConfirm(false)}
                onSecondaryActionClick={(): void => setConfirm(false)}
            />
            <p className="text-gray-700 mb-2">
                <span className="font-medium">Linked Atosa Taxpayer:</span> {atosa.name}
            </p>
            <ButtonV2
                type="danger"
                size="sm"
                label="Remove"
                onClick={(): void => setConfirm(true)}
                isLoading={unlinkTaxpayer.isLoading}
                isDisabled={unlinkTaxpayer.isLoading}
            />
        </div>
    );
}

export default LinkedTaxpayer;
